import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ccc"} }, null, -1)
const _hoisted_3 = { class: "flex flex-col gap-2 p-2 max-h-56 overflow-auto my-[4%]" }
const _hoisted_4 = { class: "px-4 py-2 rounded-full text-gray-500 bg-gray-200 font-semibold text-sm flex items-center align-center w-max ease" }

import { ref, toRef } from "@vue/reactivity";
import { PropType } from "vue";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import { fixedLenght } from "@/services/utils";
import { reformatDateDayMonth } from "@/services/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateInputChip',
  props: {
  array: {
    type: Array as PropType<string[] | null>,
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  iconName: {
    type: String,
    required: false,
  },
  isAcopled: {
    type: Boolean,
    required: false,
    default: false,
  },
  compact: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["add", "drop"],
  setup(__props, { emit }) {

const props = __props;





// State
const datesLocalRef = toRef(props, "array");
const item = ref("");
const registerForm = ref({
  items: ["USER_item"],
});
const flow = ref<VueDatePicker["flow"]>(["month", "calendar"]);

function formatDate(date: Date): string {
  const day = date.getDate();
  const month = date.getMonth() + 1;

  return `${fixedLenght(month, 2)} - ${fixedLenght(day, 2)}`;
}

/**
 * Reformatea la fecha de un formato "MM - DD" al nombre del mes con el día.
 * Por ejemplo "01 - 31" => "Enero 31"
 * @param date Fecha en formato string "MM - DD"
 */
function formatDateWithWords(date: string) {
  // Preparando formato de la fecha a uno estándar
  const [month, day] = date.split(" - ");
  date = `2022-${month}-${day}`;

  // Generando reformateo
  return reformatDateDayMonth(date);
}

function addItem(itemName: Date) {
  emit("add", formatDate(itemName));
  item.value = "";
}

function removeItem(itemIndex: number) {
  emit("drop", itemIndex);
}

function createUser() {
  alert(JSON.stringify(registerForm.value));
}

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Datepicker, {
      modelValue: _unref(item),
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => (_isRef(item) ? (item).value = $event : null)),
        addItem
      ],
      "teleport-center": "",
      flow: _unref(flow),
      "input-class-name": "newcalssinput",
      "enable-time-picker": false,
      format: "dd/MM",
      cancelText: 'Cancelar',
      selectText: 'Seleccionar'
    }, null, 8, ["modelValue", "flow"]),
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(datesLocalRef), (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "chip",
            key: index
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(formatDateWithWords(item)) + " ", 1),
              _createVNode(_component_mdicon, {
                class: "cursor-pointer",
                name: "close",
                size: "21",
                onClick: ($event: any) => (removeItem(index))
              }, null, 8, ["onClick"])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})